import type { AttributeReviewFieldDecisionInput } from "@/graphql/generated";
import type { AttributeReviewDraftSelection } from "@/hooks/useAttributeReview.types";

export function fieldDecisionFor(
  sourceFieldId: string,
  draft:
    | Pick<AttributeReviewDraftSelection, "kind" | "leaf" | "pool" | "values">
    | undefined,
): AttributeReviewFieldDecisionInput {
  return {
    sourceFieldId,
    decision: "APPROVE",
    ...(draft?.kind ? { kind: draft.kind } : {}),
    ...(draft?.leaf ? { leaf: draft.leaf } : {}),
    ...(draft?.pool ? { pool: draft.pool } : {}),
    ...(draft?.values?.length ? { values: draft.values } : {}),
  };
}

export function leafOptionsFor<T>({
  rowKind,
  optionsKind,
  pickedKind,
  options,
}: {
  rowKind: string | null;
  optionsKind: string | null;
  pickedKind: string | null;
  options: T[];
}): T[] {
  return (pickedKind ?? rowKind) === (optionsKind ?? rowKind) ? options : [];
}
